export default "__VITE_ASSET__Cx7X3U6v__";